import { useBondsBondFieldApi } from '../api';

export const useBondsBondSAccIssueDate = () => {
  const response = useBondsBondFieldApi('S_ACC.ISSUE_DATE');
  return response;
};
